module.exports = __webpack_public_path__ + "static/img/bg@2x.069c245.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg@2x.png
// module id = wbS4
// module chunks = 1